module.exports = !require('./_descriptors') && !require('./_fails')(function () {
  return Object.defineProperty(require('./_dom-create')('div'), 'a', { get: function () { return 7; } }).a != 7;
});



//////////////////
// WEBPACK FOOTER
// ./~/material-ui/~/core-js/library/modules/_ie8-dom-define.js
// module id = 472
// module chunks = 0 1